// extracted by mini-css-extract-plugin
module.exports = {"discover_item":"DiscoverService_discover_item__1v2uT","img":"DiscoverService_img__3QZ2s","wrapper":"DiscoverService_wrapper__UvnSW"};